import { render, staticRenderFns } from "./CsobajInfoBox.vue?vue&type=template&id=a493ee54&scoped=true&"
var script = {}
import style0 from "@/assets/scss/info-box.scss?vue&type=style&index=0&id=a493ee54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a493ee54",
  null
  
)

export default component.exports